module.exports = __webpack_public_path__ + "static/media/profile_picture.76659a1c.png";